module.exports = __webpack_public_path__ + "img/jzfs-j10bi_65.prt.6dee56e1.jpg";